"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDataRef = exports.buildDataRefForRedisItem = exports.buildDataRefForRedisHash = exports.isDataRefOrRecordOfDataRefs = exports.isDataRef = exports.isValidDataRefObject = void 0;
const constants_iso_1 = require("@wranggle/constants-iso");
const exceptions_1 = require("../exceptions");
const DataMarkerTrueValueSet = new Set([true, 'true', 1, '1']);
const InvalidDataRefArgsErrorCode = 'InvalidDataRefArgs'; // todo: mv to central error codes
function isValidDataRefObject(dataRef) {
    return isDataRef(dataRef) &&
        DataMarkerTrueValueSet.has(dataRef[constants_iso_1.DataRefMarker]) &&
        typeof (dataRef.serviceConnUid === 'string') && // perhaps validate length
        dataRef.dataType &&
        !!(dataRef.namespace || dataRef.key);
}
exports.isValidDataRefObject = isValidDataRefObject;
function isDataRef(obj) {
    return !!(obj && typeof obj === 'object' && obj[constants_iso_1.DataRefMarker]);
}
exports.isDataRef = isDataRef;
function isDataRefOrRecordOfDataRefs(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }
    if (isValidDataRefObject(obj)) {
        return true;
    }
    return Object.values(obj).every((item) => isValidDataRefObject(item));
}
exports.isDataRefOrRecordOfDataRefs = isDataRefOrRecordOfDataRefs;
function buildDataRefForRedisHash(args) {
    return buildDataRef(Object.assign({
        dataType: 'RedisHash',
    }, args));
}
exports.buildDataRefForRedisHash = buildDataRefForRedisHash;
function buildDataRefForRedisItem(args) {
    if (args.namespace) {
        throw new exceptions_1.PlusPlusPlus(InvalidDataRefArgsErrorCode, {
            reason: 'namespace msut be empty for dataType RedisItem, use key instead'
        });
    }
    return buildDataRef(Object.assign({
        dataType: 'RedisItem',
    }, args));
}
exports.buildDataRefForRedisItem = buildDataRefForRedisItem;
function buildDataRef(args) {
    const res = Object.assign({
        createdAt: Date.now(), // sticking with epochMs.. vs (new Date()).toISOString(),
    }, args, {
        [constants_iso_1.DataRefMarker]: true,
    });
    if (!isValidDataRefObject(res)) {
        throw new exceptions_1.PlusPlusPlus(InvalidDataRefArgsErrorCode, Object.assign({}, args));
    }
    return res;
}
exports.buildDataRef = buildDataRef;
//# sourceMappingURL=data-ref-util.js.map